module.exports = __webpack_public_path__ + "img/bee.c471db57.svg";